import Swiper from 'swiper';
const brandsSlider = document.querySelectorAll(".brands-slider .slider");

if(brandsSlider){
  brandsSlider.forEach((el) => {
        const swiper = new Swiper (el, {
          slidesPerView: 1,
          spaceBetween: 24,
          navigation: {
            nextEl: '.next',
            prevEl: '.prev',
          },
          breakpoints: {
            1024: {
              slidesPerView: 5,
              spaceBetween: 40
            }
          }
        })
    })
}